
import { useTranslation } from '../../../hooks/useTranslation';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-black border-t border-cyan-500/20 py-8">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Copyright */}
          <div className="text-gray-400 font-mono text-sm">
            {t('footerText')}
          </div>

          {/* Terminal animation */}
          <div className="flex items-center space-x-2 text-cyan-400 font-mono text-xs">
            <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
            <span className="text-gray-500">0x23F connections online</span>
          </div>

          {/* Quick link */}
          <div className="text-gray-500 font-mono text-xs">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-cyan-400 transition-colors duration-300 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
